import { ServiceRequestDetailsClientDTO } from "@shared/models/service-request-details-client-dto";
import { Component, Inject, Injector, OnInit } from "@angular/core";
import { AbstractControl, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { KeycloakService } from "keycloak-angular";
import { take } from "rxjs/operators";
import { GenericComponent } from "../../components/generic.component";
import { BudgetPartItemsDTO } from "../../models/budget-part-items-dto";
import { RoleEnum } from "../../enums/roles.enum";
import { MeasurementUnitDTO } from "../../models/measurement-unit-dto";
import IsCountryHelper from "../../helper/country.helper";
import { ClientTypeEnum } from "@shared/enums/client-type.enum";
import { BudgetDetails } from "@shared/models/service-request-details-dto";
import { KeycloakHelperService } from "@core/services/keycloak.helper.service";
import { MonetaryService } from "@core/services/monetary.service";
import { ValidatorsService } from "@shared/validators/validators.service";
import { MatSlideToggleChange } from "@angular/material/slide-toggle";

interface PropsType {
  client: ServiceRequestDetailsClientDTO;
  budget: BudgetDetails;
  isFee?: boolean;
}

@Component({
  selector: "app-smartfleet-budget-part-item-form-modal",
  templateUrl: "./budget-part-item-form-modal.component.html",
  styleUrls: ["./budget-part-item-form-modal.component.scss"],
  standalone: false
})
export class BudgetPartItemFormModalComponent
  extends GenericComponent
  implements OnInit
{
  labelPartCarWorkshopPrice: string;
  labelPartClientPrice: string;
  labelServiceCarWorkshopPrice: string;
  labelServiceClientPrice: string;

  //hora
  hours = [
    { time: "00", value: 0 },
    { time: "01", value: 1 },
    { time: "02", value: 2 },
    { time: "03", value: 3 },
    { time: "04", value: 4 },
    { time: "05", value: 5 },
    { time: "06", value: 6 },
    { time: "07", value: 7 },
    { time: "08", value: 8 },
    { time: "09", value: 9 },
    { time: "10", value: 10 },
    { time: "11", value: 11 },
    { time: "12", value: 12 },
    { time: "13", value: 13 },
    { time: "14", value: 14 },
    { time: "15", value: 15 },
    { time: "16", value: 16 },
    { time: "17", value: 17 },
    { time: "18", value: 18 },
    { time: "19", value: 19 },
    { time: "20", value: 20 },
    { time: "21", value: 21 },
    { time: "22", value: 22 },
    { time: "23", value: 23 }
  ];
  minutes = [
    { time: "00", value: 0 },
    { time: "15", value: 0.25 },
    { time: "30", value: 0.5 },
    { time: "45", value: 0.75 }
  ];
  selectedHours = 0;
  selectedHoursService = 0;
  selectedMinutes = 0;
  selectedMinutesService = 0;
  totalTime = 0;
  totalTimeService = 0;

  partPriceForm = this.fb.group({
    partManufacturerName: ["", [Validators.required]],
    partCode: [""],
    partName: ["", [Validators.required]],
    customPart: [true],
    carWorkshopPrice: ["", [Validators.required]],
    clientPrice: ["", [Validators.required]],
    measurementUnit: ["", [Validators.required]],
    partAmount: ["", [Validators.required]],
    tire: [false, [Validators.required]],
    courtesy: [false, [Validators.required]],
    guarantee: [false, [Validators.required]],
    budgetServiceItem: this.fb.group({
      carWorkshopPrice: ["", [Validators.required]],
      clientPrice: ["", [Validators.required]],
      serviceName: [{ value: "", disabled: true }, [Validators.required]],
      amountOfHours: [""],
      selectedHours: [""],
      selectedMinutes: [""]
    })
  });
  budgetPartItems: BudgetPartItemsDTO;
  isBrazilian = false;
  constructor(
    private keycloakService: KeycloakService,
    injector: Injector,
    @Inject(MAT_DIALOG_DATA) private data: PropsType,
    private matDialogRef: MatDialogRef<BudgetPartItemFormModalComponent>,
    private keycloakHelperService: KeycloakHelperService,
    private monetaryService: MonetaryService,
    private validatorsService: ValidatorsService
  ) {
    super(injector);
  }

  ngOnInit() {
    this.isBrazilian = this.keycloakHelperService.isBrazilian();
    this.buildPage();

    if (
      this.isBoschClient() ||
      this.clientIsBrazilianAndRBLA() ||
      this.isCarWorkshopLogged()
    ) {
      this.partPriceForm.get("clientPrice").disable();
      this.partPriceForm.get("budgetServiceItem.clientPrice").disable();
    }

    if (
      (this.isBackofficeOperationLogged() ||
        this.isBackofficeExternalLogged() ||
        this.isBackofficeApproverManagerLogged() ||
        this.isBackofficeAdministratorLogged()) &&
      this.isBrazilian
    ) {
      this.partPriceForm.addControl("pnErpCode", this.fb.control(""));
    }

    if (this.clientIsBrazilianAndNotRBLA()) {
      this.partPriceForm.get("clientPrice").disable();
    }

    this.setupToggleListeners();
  }

  buildPage(): void {
    const strings = [
      "label-unit-value",
      "label-change-part-price-labor",
      "car-workshop-title",
      "input-client-name"
    ];

    this.translateService
      .get(strings)
      .pipe(take(1))
      .subscribe((message) => {
        if (
          this.isBackofficeOperationLogged() ||
          this.isBackofficeExternalLogged() ||
          this.isBackofficeApproverManagerLogged() ||
          this.isBackofficeAdministratorLogged()
        ) {
          this.labelPartCarWorkshopPrice =
            message["label-unit-value"] + " " + message["car-workshop-title"];
          this.labelPartClientPrice =
            message["label-unit-value"] + " " + message["input-client-name"];
          this.labelServiceCarWorkshopPrice =
            message["label-change-part-price-labor"] +
            " " +
            message["car-workshop-title"];
          this.labelServiceClientPrice =
            message["label-change-part-price-labor"] +
            " " +
            message["input-client-name"];
        } else {
          this.labelPartCarWorkshopPrice = message["label-unit-value"];
          this.labelPartClientPrice = message["label-unit-value"];
          this.labelServiceCarWorkshopPrice =
            message["label-change-part-price-labor"];
          this.labelServiceClientPrice =
            message["label-change-part-price-labor"];
        }
      });
  }

  isBackofficeOperationLogged() {
    return this.keycloakService
      .getUserRoles()
      .includes(RoleEnum.BACKOFFICE_OPERATION);
  }

  isBackofficeExternalLogged() {
    return this.keycloakService
      .getUserRoles()
      .includes(RoleEnum.BACKOFFICE_EXTERNAL);
  }

  isBackofficeApproverManagerLogged() {
    return this.keycloakService
      .getUserRoles()
      .includes(RoleEnum.BACKOFFICE_APPROVER_MANAGER);
  }

  isBackofficeAdministratorLogged() {
    return this.keycloakService
      .getUserRoles()
      .includes(RoleEnum.BACKOFFICE_ADMINISTRATOR);
  }

  isCarWorkshopLogged() {
    return this.keycloakService.getUserRoles().includes(RoleEnum.CAR_WORKSHOP);
  }

  isBoschClient() {
    return (
      (this.data.client.clientType === ClientTypeEnum.RBLA_COMMON &&
        this.data.client.tradingName?.toLowerCase().includes("bosch")) ||
      (this.data.client.clientType === ClientTypeEnum.RBLA_CAR_RENTAL &&
        this.data.budget.clientApproverProfile == "DRIVER_APPROVER")
    );
  }

  clientIsBrazilianAndRBLA(): boolean {
    return (
      IsCountryHelper.isBrazil(this.data.client.countryName) &&
      this.isBoschClient()
    );
  }

  clientIsBrazilianAndNotRBLA(): boolean {
    return (
      IsCountryHelper.isBrazil(this.data.client.countryName) &&
      !this.isBoschClient()
    );
  }

  closeDialog(isSubmitted: boolean): void {
    if (isSubmitted) {
      if (this.partPriceForm.valid) {
        this.matDialogRef.close(this.partPriceForm.getRawValue());
      }
    } else {
      this.matDialogRef.close(null);
    }
  }

  get getFormControls() {
    return this.partPriceForm.controls;
  }

  handleServiceClientPrice() {
    this.partPriceForm
      .get("budgetServiceItem.clientPrice")
      .setValidators([
        Validators.required,
        this.validatorsService.biggerOrEqualValidator(
          this.partPriceForm.get("budgetServiceItem.carWorkshopPrice").value,
          this.partPriceForm.get("budgetServiceItem.clientPrice").value
        )
      ]);

    this.partPriceForm
      .get("budgetServiceItem.clientPrice")
      .updateValueAndValidity();

    this.partPriceForm.markAllAsTouched();
  }

  handlePartCarWorkshopPrice(event: Event) {
    if (
      this.isBoschClient() ||
      this.clientIsBrazilianAndRBLA() ||
      this.clientIsBrazilianAndNotRBLA()
    ) {
      const input = event.target as HTMLInputElement;
      this.partPriceForm.get("clientPrice").setValue(input.value);

      if (this.monetaryService.monetaryStringToFloat(input.value) == 0) {
        this.partPriceForm.get("carWorkshopPrice").setErrors({
          minValue: true
        });
      }
    }
  }

  handleServiceCarWorkshopPrice() {
    if (this.isBoschClient() || this.clientIsBrazilianAndRBLA() || !this.data.isFee) {
      this.partPriceForm
        .get("budgetServiceItem.clientPrice")
        .setValue(
          this.partPriceForm.get("budgetServiceItem.carWorkshopPrice").value
        );
    }

    this.handleServiceClientPrice();
  }

  handlePartNameChange(): void {
    const partName = this.partPriceForm.get("partName").value;
    let serviceName = "";
    if (partName) {
      serviceName = `${this.translateService.instant("change")} ${partName}`;
    }
    this.partPriceForm
      .get("budgetServiceItem.serviceName")
      .setValue(serviceName);
  }

  handleUnitChange(measurementUnit: MeasurementUnitDTO): void {
    this.partPriceForm.get("measurementUnit").setValue(measurementUnit.value);
  }

  setHours(e) {
    this.selectedHours = e.value == "0" ? 0 : e.value;
    this.setTime();
  }

  setMinutes(e) {
    this.selectedMinutes = e.value == "0" ? 0 : e.value;
    this.setTime();
  }

  setTime() {
    this.totalTime = this.selectedHours + this.selectedMinutes;
    this.partPriceForm
      .get("budgetServiceItem.amountOfHours")
      .setValue(this.totalTime);
    if (this.totalTime == 0) {
      this.partPriceForm.get("budgetServiceItem.amountOfHours").setValue("");
    }
  }

  handleManufacturerChange(e) {
    this.partPriceForm.get("partCode").setValue("");
  }

  getOnlyNumbersMask() {
    return this.maskService.getOnlyNumbersMask();
  }

  getThousandSeparator() {
    return this.maskService.getThousandSeparator();
  }

  isBackofficesOrCarWorkshopLogged() {
    return (
      this.isBackofficeOperationLogged() ||
      this.isBackofficeExternalLogged() ||
      this.isBackofficeApproverManagerLogged() ||
      this.isBackofficeAdministratorLogged() ||
      this.isCarWorkshopLogged()
    );
  }

  private setupToggleListeners(): void {
    this.onGuaranteeChange();
    this.onCourtesyChange();
  }

  private onGuaranteeChange(): void {
    this.partPriceForm.get('guarantee')?.valueChanges.subscribe((value: boolean) => {
      const courtesyControl = this.partPriceForm.get('courtesy');
      if (value) {
        this.disableAndUncheck(courtesyControl);
      } else {
        courtesyControl?.enable({ emitEvent: false });
      }
    });
  }

  private onCourtesyChange(): void {
    this.partPriceForm.get('courtesy')?.valueChanges.subscribe((value: boolean) => {
      const guaranteeControl = this.partPriceForm.get('guarantee');
      if (value) {
        this.disableAndUncheck(guaranteeControl);
      } else {
        guaranteeControl?.enable({ emitEvent: false });
      }
    });
  }

  private disableAndUncheck(control: AbstractControl | null): void {
    control?.setValue(false, { emitEvent: false });
    control?.disable({ emitEvent: false });
  }

  handleGuaranteeAndCourtesy(event: MatSlideToggleChange): void {
    const { checked } = event;

    const fields = [
      'carWorkshopPrice',
      'clientPrice',
      'budgetServiceItem.carWorkshopPrice',
      'budgetServiceItem.clientPrice'
    ];

    fields.forEach(field => {
      const control = this.partPriceForm.get(field);
      if (!control) return;

      if (checked) {
        control.setValue("0,00", { emitEvent: false });
        control.disable({ emitEvent: false });
      } else {
        control.enable({ emitEvent: false });
      }
    });
  }
}
